<script>
import Swal from "sweetalert2";
import store from "@/state/store";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrOdenekTalep from "@/models/StrOdenekTalep";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import StrKontrolGirisKanit from "../../StrKurumsalPerformans/StrKontrolGirisKanit/AddEdit.vue";
import AddEdit from "./AddEdit.vue";
import SonGun from "./SonGun.vue";
import Onay from "./Onay.vue";
import Iade from "./Iade.vue";
import moment from "moment";

import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrOdenekTalep],
  page: {
    title: "Ödenek Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    AddEdit,
    formcombobox,
    BirimSecimi,
    Treeselect,
    Onay,
    Iade,
    SonGun,
    StrKontrolGirisKanit
  },
  data() {
    return {
      title: this.$t("StrOdenekTalep.Title"),
      items: [
        {
          text: this.$t("StrOdenekTalep.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrOdenekTalep.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrOdenekTalep.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Page2: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FilitrelemePenceresi: false,
      TableData: {},
      OPersonelid: null,
      DataUpdate: "",
      DataPrint: "",
      AddEdit: "",
      DataUpdate2: "",
      DataUpdate3: "",
      AddEdit2: "",
      aktif_yil:null,
      gizle:0,
      UserId: null,
      TableDataTutarlar: [],
      ComboBoxBirimId: [],
      ComboBoxDonemId: [],
      ComboBoxStrAmacId: [],
      ComboBoxPerformanHedef: [],
      ComboBoxStratejikFaliyet: [],
      ComboBoxHarcamaTipi: [],
      ComboBoxIhaleTipi: [],
      ComboBoxVeriGirisiYapan: [],
      ComboBoxGerceklestirmeGorevlisi: [],
      ComboBoxDonem: [],
      Odenekid:  "",
      Giderturs:[
                {"Id":"1","Value":"Personel Giderleri"},
                {"Id":"2","Value":"Diğer Giderler"}
              ],
      GetAll: false,
      Aylar:[
          {Id:"1",Value:"Ocak", Deleted:"true"},
          {Id:"2",Value:"Şubat", Deleted:"true"},
          {Id:"3",Value:"Mart", Deleted:"true"},
          {Id:"4",Value:"Nisan", Deleted:"true"},
          {Id:"5",Value:"Mayıs", Deleted:"true"},
          {Id:"6",Value:"Haziran", Deleted:"true"},
          {Id:"7",Value:"Temmuz", Deleted:"true"},
          {Id:"8",Value:"Ağustos", Deleted:"true"},
          {Id:"9",Value:"Eylül", Deleted:"true"},
          {Id:"10",Value:"Ekim", Deleted:"true"},
          {Id:"11",Value:"Kasım", Deleted:"true"},
          {Id:"12",Value:"Aralık", Deleted:"true"},

        ],
        Yillar:[
          {Id:"2020",Value:"2020", Deleted:"true"},
          {Id:"2021",Value:"2021", Deleted:"true"},
          {Id:"2022",Value:"2022", Deleted:"true"},
          {Id:"2023",Value:"2023", Deleted:"true"},
          {Id:"2024",Value:"2024", Deleted:"true"},
          {Id:"2025",Value:"2025", Deleted:"true"}

        ],
      Aylar2 : [],
      HesapKods: {},
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      ComboBoxOnay: [
        { Id: "True", Value: "Onaylı" },
        { Id: "False", Value: "Onaysız" },
      ],
      ComboBoxStrPerformansHedefiId: [],
      Filter: {
        Birimid: null,
        Hesapkodid: null,
        Yil: null,
        Ay: null,
        Onay: false,
        Gidertur: null
      },
      IsLevelTwo: false,
      siralama:"&Desc=Yil&Desc=Ay&Desc=Created",
      AdminRoleKontrol: false,
      Tarih: moment(new Date()).format("YYYY-MM-DD"),
    };
  },
  validations: {
    Filter: {
      BirimId:{},
      Hesapkodid: {},
      Yil: {},
      Ay: {},
      Onay: {},
      Gidertur: {}

    },
  },
  methods: {
getStatusStyle(item) {

      if (item.Iptal) {
        return { backgroundColor: '#F48FB1', color: '' };
      }
      if (item.Onay) {
        return { backgroundColor: '#E8F5E9', color: 'green' };
      }
      if(item.Revize || !item.Revize && !item.Onay && !item.Revize) {
        return { backgroundColor: '#f0f0f0', color: 'black' };
      }
    },
    Get() {


      this.$v.$touch();
          if (!this.$v.$invalid) {
            let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
this.ActionsFilterGet({Service: "ouygulama",  Page:Page,Filter:'&Kisaadi=STR'}).then((ouygulama) => {
    if(ouygulama){

    this.ActionsFilterGet({Service: "ouserbirimyetki",
    Page:Page,
    Filter:'&Uygulamaid='+ ouygulama.Data[0].Id + '&Userid='+this.UserId}).then((ouserbirimyetki) => {

    if(ouserbirimyetki && ouserbirimyetki.Data.length > 0){

              let Filter = "";
              if (this.Filter.BirimId!=null && this.Filter.BirimId!="") Filter = Filter + "&Birimid=" + this.Filter.BirimId;
              if (this.Filter.Hesapkodid!=null && this.Filter.Hesapkodid!="") Filter = Filter + "&Hesapkodid=" + this.Filter.Hesapkodid;
              if (this.Filter.Yil!=null && this.Filter.Yil!="") Filter = Filter + "&Yil=" + this.Filter.Yil;
              if (this.Filter.Ay!=null && this.Filter.Ay!="") Filter = Filter + "&Ay=" + this.Filter.Ay;
              if (this.Filter.Onay!=null && this.Filter.Onay!="") Filter = Filter + "&Onay=" + this.Filter.Onay;
              if (this.Filter.Gidertur!=null && this.Filter.Gidertur!="") Filter = Filter + "&Gidertur=" + this.Filter.Gidertur;
              if(this.siralama!=null && this.siralama!=""){Filter=Filter+this.siralama;}
              if(this.GetAll == false){
                this.ActionsFilterGet({
                Service: "StrOdenekTalep",
                Page: this.Page,
                Filter: Filter,
              }).then((res) => {
                this.TableData = res.Data;
                  this.Page.PageDataSize = res.TotalCount;
                this.FilitrelemePenceresi = false;
              });
              }else{
                this.ActionsFilterGet({
                Service: "StrOdenekTalep",
                Page: this.Page2,
                Filter: Filter,
              }).then((res) => {
               this.TableData = res.Data;
                this.Page2.PageDataSize = res.TotalCount;
                this.FilitrelemePenceresi = false;
              });
              }
            }
});
    }
});

        }
    },
    FilterHesapKodu(KodId) {
      let Filter = this.HesapKods.filter((notification) =>
        notification.Id.includes(KodId)
      )[0];
      if (Filter) {
        return Filter.Kod;
      } else {
        return;
      }
    },
    loadOptions({ action,  callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          const options = this.FormDataType.Hesapkodid.ComboDataArray;

          callback(null, options)
        })
      }
    },
hesapkodu(Aciklama){
this.FormDataType.Hesapkodid.ComboDataArray = []
  if(this.IsLevelTwo){
    this.hesapkodu_sorgula_ikincibas(Aciklama)

  }else{
this.hesapkodu_sorgula(Aciklama)
}
},
    hesapkodu_sorgula(Aciklama){

            let Page= {
            PageNumber: "1",
            PageSize: "100"
            }

            if (Aciklama.length>=1){

                  let Filter = "&Basamak=4&Aciklama="+Aciklama;
                  this.FormDataType.Hesapkodid.ComboDataArray=[];

                  this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {
                  this.FormDataType.Hesapkodid.ComboDataArray = []
                    for(var i=0; i<res.Data.length; i++)
                      {
                        this.FormDataType.Hesapkodid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})
                      }
                  });
            }

    },
    hesapkodu_sorgula_ikincibas(Aciklama){
            let Page= {
            PageNumber: "1",
            PageSize: "100"
            }
            if (Aciklama.length>=1){
                  let Filter = "&Basamak=2&Aciklama="+Aciklama;
                  this.FormDataType.Hesapkodid.ComboDataArray=[];
                  this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {
                  this.FormDataType.Hesapkodid.ComboDataArray = []
                    for(var i=0; i<res.Data.length; i++)
                      {
                        this.FormDataType.Hesapkodid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})
                      }
                  });
            }

    },
    GetAylar(){
      const d = new Date();
      const currentMonth = d.getMonth() + 1;
      for (let i = 0; i < currentMonth; i++) {
        this.Aylar2.push(this.Aylar[i]);
      }
    },
    Onay(Data) {

      Swal.fire({
        title: this.$t("StrOdenekTalep.ToasMessage.Baslik"),
        text: this.$t("StrOdenekTalep.ToasMessage.Content"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("StrOdenekTalep.ToasMessage.Pozitif"),
        cancelButtonText: this.$t("StrOdenekTalep.ToasMessage.Negatif"),
      }).then((result) => {
        if (result.value) {

        Data.Onaypersonelid = this.OPersonelid;
        Data.Onay = true;
        this.Update("StrOdenekTalep", Data).then((res) => {
          if (res) {
            this.Get();

          }
        });

      }

      });


    },
    Onayiptal(Data) {

          Swal.fire({
            title: this.$t("StrOdenekTalep.ToasMessage.IptalBaslik"),
            text: this.$t("StrOdenekTalep.ToasMessage.IptalContent"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: this.$t("StrOdenekTalep.ToasMessage.IptalPozitif"),
            cancelButtonText: this.$t("StrOdenekTalep.ToasMessage.IptalNegatif"),
          }).then((result) => {
            if (result.value) {
var Form = {
  "GrupGuid": Data.GrupGuid
}
           this.ActionsAllPut({ Service: "StrOdenekTalep/OnayIptalByGrupGuid", Data: Form }).then((res)=> {
            if (res.Succeeded == true) {
              this.$toast.success(res.Message);
              this.Get();


            } else {
              this.$toast.error(res.Errors);
            }
          });

      }

      });


    },
        Revizegonder(Data) {

          Swal.fire({
            title: 'Gerekli düzenlemelerin yapıldığını onaylıyor musunuz?',
            text: 'Ödenek Talebi Tekrar İletilecektir',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır',
          }).then((result) => {
                      if (result.value) {
                      var Form = {
                        "GrupGuid": Data.GrupGuid
                      }
                    this.ActionsAllPut({ Service: "StrOdenekTalep/RevizeGonderByGrupGuid", Data: Form }).then((res)=> {
                      if (res.Succeeded == true) {
                        this.$toast.success(res.Message);
                        this.Get();


                      } else {
                        this.$toast.error(res.Errors);
                      }
                    });

      }

      });


    },


    ExcelExport(table, name){

          this.gizle=1;

          setTimeout(() => {

              if (!table.nodeType) table = this.$refs.odenektalepraporu;
              var html =table.innerHTML
              var ctx = {worksheet: name || 'Worksheet', table:html }
              var a = document.createElement('a');
              a.href = this.uri +this.base64(this.format(this.template, ctx));
              a.download = name + '.xls';
              a.click();

              this.gizle=0;

          }, 1000);

 },

  DeleteOdenekGrup(GrupGuid) {
            Swal.fire({
            title: 'Ödenek Talep Silinsin Mi?',
            text: 'Emin Misiniz?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır',
          }).then((result) => {
            if (result.value) {
        this.ActionsDelete({ Service: 'strodenektalep/DeleteByGrupGuid', Id : GrupGuid }).then((res) => {
          if (res.Succeeded == true) {
            this.Get();
            this.$toast.success(res.Message);

            return true;
          } else {
            this.$toast.error(res.Errors);
          }
        });
              }

      });
},



    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    yetki_kontrol(yetki){

      var sonuc = this.KullaniciBilgileri.indexOf(yetki);

      return sonuc;

      },
  },
  created() {
    this.GetAylar();
    let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
      this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:"&Basamak=4"}).then(res => {
        this.HesapKods = res.Data;
      });

      this.UserId = store.getters["auth/TokenUserId"]
    let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin")
      );
      if (YetkiSorgu.length != 0) this.AdminRoleKontrol = true;

    this.KullaniciBilgileri = store.getters["auth/UserRolles"];

    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.ComboBoxBirimId.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });
      }
    });
    let Filter = "&Eposta=" + this.UserEMail;
      this.ActionsFilterGet({
        Service: "OPersonel",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        this.OPersonelid = res.Data[0].Id;
      });

  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.StrOdenekSonGun
                      v-if="
                        yetki_kontrol('StrAdmin') >= 0 ||
                          yetki_kontrol('SuperAdmin') >= 0
                      "
                    >
                      <i class="mdi mdi-check me-1"></i>
                      Son Gün Değiştir
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrOdenekTalep.Page.Filtreleme") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="(GetAll = !GetAll), Get()"
                    >
                      <i class="mdi mdi-download me-1"></i>
                      Tümünü Getir
                    </button>

                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="ExcelExport('Ödenek Talep', 'Ödenek Talep')"
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Excel'e Aktar
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.StrOdenekTalep
                      @click="
                        (DataUpdate = StrOdenekTalepData), (AddEdit = 'Add')
                      "
                    >
                      <i class="mdi mdi-plus me-1"></i>
                      {{ $t("StrOdenekTalep.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table
                  ref="odenektalepraporu"
                  style="border: 1px solid; border-collapse: collapse; "
                  border="1"
                  class="table table-bordered mb-0"
                >
                  <thead class="table-light">
                    <tr>
                      <th>
                        {{ $t("StrOdenekTalep.Table.Birimid") }}
                        <i
                          style="margin-left:10px"
                          v-if="siralama != '&Asc=BirimAdi'"
                          @click="(siralama = '&Asc=BirimAdi'), Get()"
                          class="bx bx-sort-a-z fa-xl"
                        ></i>
                        <i
                          style="margin-left:10px"
                          v-if="siralama == '&Asc=BirimAdi'"
                          @click="(siralama = '&Desc=BirimAdi'), Get()"
                          class="bx bx-sort-z-a  fa-xl"
                        ></i>
                      </th>
                      <th>
                        {{ $t("StrOdenekTalep.Table.Yil") }}
                        <i
                          style="margin-left:10px"
                          v-if="siralama != '&Asc=Yil'"
                          @click="(siralama = '&Asc=Yil'), Get()"
                          class="bx bx-sort-a-z fa-xl"
                        ></i>
                        <i
                          style="margin-left:10px"
                          v-if="siralama == '&Asc=Yil'"
                          @click="(siralama = '&Desc=Yil'), Get()"
                          class="bx bx-sort-z-a  fa-xl"
                        ></i>
                      </th>
                      <th>
                        {{ $t("StrOdenekTalep.Table.Ay") }}
                        <i
                          style="margin-left:10px"
                          v-if="siralama != '&Asc=Ay'"
                          @click="(siralama = '&Asc=Ay'), Get()"
                          class="bx bx-sort-a-z fa-xl"
                        ></i>
                        <i
                          style="margin-left:10px"
                          v-if="siralama == '&Asc=Ay'"
                          @click="(siralama = '&Desc=Ay'), Get()"
                          class="bx bx-sort-z-a  fa-xl"
                        ></i>
                      </th>
                      <th>{{ $t("StrOdenekTalep.Table.Program") }}</th>
                      <th>{{ $t("StrOdenekTalep.Table.AltProgram") }}</th>
                      <th>{{ $t("StrOdenekTalep.Table.Faaliyet") }}</th>
                      <th>{{ $t("StrOdenekTalep.Table.AltFaaliyet") }}</th>
                      <th>
                        {{ $t("StrOdenekTalep.Table.Hesapkodid") }}
                        <i
                          style="margin-left:10px"
                          v-if="siralama != '&Asc=Hesapadi'"
                          @click="(siralama = '&Asc=Hesapadi'), Get()"
                          class="bx bx-sort-a-z fa-xl"
                        ></i>
                        <i
                          style="margin-left:10px"
                          v-if="siralama == '&Asc=Hesapadi'"
                          @click="(siralama = '&Desc=Hesapadi'), Get()"
                          class="bx bx-sort-z-a  fa-xl"
                        ></i>
                      </th>
                      <th>
                        {{ $t("StrOdenekTalep.Table.Serbestodenek") }}
                      </th>
                      <!--         <th>
                        {{ $t("StrOdenekTalep.Table.Blokeodenek") }}
                      </th> -->
                      <th>
                        {{ $t("StrOdenekTalep.Table.Harcananodenek") }}
                      </th>
           
                      <th>{{ $t("StrOdenekTalep.Table.Kalanodenek") }}</th>
                      <th>Ödeme Tutarı</th>
                                 <th>
                        {{ $t("StrOdenekTalep.Table.Talepedilenodenek") }}
                      </th>
                      <th>{{ $t("StrOdenekTalep.Table.Aciklama") }}</th>

                      <th>{{ $t("StrOdenekTalep.Table.OnayAciklama") }}</th>
                      <th>{{ $t("StrOdenekTalep.Table.IadeAciklama") }}</th>
                      <th v-if="gizle == 0">
                        Durum
                      </th>
                      <th
                        v-if="gizle == 0"
                        style="width: 85px; text-align: center;"
                      >
                        {{ $t("StrOdenekTalep.Table.Islem") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(TableDataVerileri, index) in TableData"
                      :key="index"
                    >
                      <td>{{ TableDataVerileri.Birimadi }}</td>
                      <td>{{ TableDataVerileri.Yil }}</td>
                      <td>{{ TableDataVerileri.Ay }}</td>
                      <td>{{ TableDataVerileri.ProgramAd }}</td>
                      <td>{{ TableDataVerileri.AltprogramAd }}</td>
                      <td>{{ TableDataVerileri.FaaliyetAd }}</td>
                      <td>{{ TableDataVerileri.AltfaaliyetAd }}</td>
  <td>
  <div v-for="(Data2, i) in TableDataVerileri.Hesapkods" :key="i">
    {{ Data2 }}
    <hr />

  </div>
    <strong>   Toplam:</strong> 
</td>

<td>
  <div v-for="(val, i) in TableDataVerileri.Serbestodenekler" :key="i">
    {{ val | TrParaFormat }}
    <hr />
  </div>
  <strong> {{ TableDataVerileri.Serbestodenekler.reduce((a, b) => a + b, 0) | TrParaFormat }}</strong>
</td>

<td>
  <div v-for="(val, i) in TableDataVerileri.Harcananodenekler" :key="i">
    {{ val | TrParaFormat }}
    <hr />
  </div>
  <strong> {{ TableDataVerileri.Harcananodenekler.reduce((a, b) => a + b, 0) | TrParaFormat }}</strong>
</td>

<td>
  <div v-for="(val, i) in TableDataVerileri.Kalanodenekler" :key="i">
    {{ val | TrParaFormat }}
    <hr />
  </div>
  <strong> {{ TableDataVerileri.Kalanodenekler.reduce((a, b) => a + b, 0) | TrParaFormat }}</strong>
</td>

<td>
  <div v-for="(val, i) in TableDataVerileri.Odemetutarlari" :key="i">
    {{ val | TrParaFormat }}
    <hr />
  </div>
  <strong> {{ TableDataVerileri.Odemetutarlari.reduce((a, b) => a + b, 0) | TrParaFormat }}</strong>
</td>

<td>
  <div v-for="(val, i) in TableDataVerileri.Talepedilenodenekler" :key="i">
    {{ val | TrParaFormat }}
    <hr />
  </div>
  <strong> {{ TableDataVerileri.Talepedilenodenekler.reduce((a, b) => a + b, 0) | TrParaFormat }}</strong>
</td>

                      <td>{{ TableDataVerileri.Aciklama }}</td>

                      <td>{{ TableDataVerileri.Onayaciklama }}</td>
                      <td>{{ TableDataVerileri.Iptalaciklama }}</td>
                      <td
                        v-if="gizle == 0"
                        style="vertical-align: middle; text-align: center;"
                      >
                        <span v-if="TableDataVerileri.Onay">Onaylı</span>
                        <span
                          v-if="
                            !TableDataVerileri.Onay &&
                              !TableDataVerileri.Iptal &&
                              !TableDataVerileri.Revize
                          "
                          >Onaysız</span
                        >
                        <span v-if="TableDataVerileri.Iptal"
                          >İptal Revize Bekliyor</span
                        >
                        <span v-if="TableDataVerileri.Revize"
                          >Revize Edildi</span
                        >
                      </td>
                      <td
                        v-if="gizle == 0"
                        style="width: 85px; text-align: center; vertical-align: middle;"
                      >
                        <b-button-group>
                          <b-button
                            variant="danger"
                            v-if="
                              !TableDataVerileri.Iptal &&
                                !TableDataVerileri.Revize &&
                                !TableDataVerileri.Onay &&
                                TableDataVerileri.Talepedilenodenek > 0 &&
                                (yetki_kontrol('StrHarcamaGirisOnay') >= 0 ||
                                  yetki_kontrol('StrAdmin') >= 0 ||
                                  yetki_kontrol('SuperAdmin') >= 0)
                            "
                            v-b-modal.StrOdenekTalepIade
                            @click="DataUpdate3 = TableDataVerileri"
                            ><i class="fas fas fa-times"></i>
                          </b-button>
                          <b-button
                            variant="success"
                            v-if="
                              !TableDataVerileri.Onay &&
                                !TableDataVerileri.Iptal &&
                                TableDataVerileri.Talepedilenodenek > 0 &&
                                (yetki_kontrol('StrHarcamaGirisOnay') >= 0 ||
                                  yetki_kontrol('StrAdmin') >= 0 ||
                                  yetki_kontrol('SuperAdmin') >= 0)
                            "
                            v-b-modal.StrOdenekTalepOnay
                            @click="DataUpdate2 = TableDataVerileri"
                            ><i class="fas fas fa-check-double"></i>
                          </b-button>
                          <b-button
                            variant="warning"
                            v-if="
                              TableDataVerileri.Iptal &&
                                (yetki_kontrol('StrHarcamaGirisOnay') >= 0 ||
                                  yetki_kontrol('StrAdmin') >= 0 ||
                                  yetki_kontrol('SuperAdmin') >= 0)
                            "
                            @click="Revizegonder(TableDataVerileri)"
                            ><i class="fas fas fa-reply-all"></i>
                          </b-button>
                          <b-button
                            variant="warning"
                            v-if="
                              TableDataVerileri.Onay &&
                                (yetki_kontrol('StrHarcamaGirisOnay') >= 0 ||
                                  yetki_kontrol('StrAdmin') >= 0 ||
                                  yetki_kontrol('SuperAdmin') >= 0)
                            "
                            @click="Onayiptal(TableDataVerileri)"
                            ><i class="fas fas fa-reply-all"></i>
                          </b-button>
                          <b-button
                            variant="primary"
                            v-if="
                              !TableDataVerileri.Onay &&
                                !TableDataVerileri.Revize
                            "
                            v-b-modal.StrOdenekTalep
                            @click="
                              (DataUpdate = TableDataVerileri),
                                (AddEdit = 'Edit')
                            "
                            ><i class="fas fa-pencil-alt"></i
                          ></b-button>

                          <b-button
                            variant="warning"
                            v-if="
                              !TableDataVerileri.Onay &&
                                !TableDataVerileri.Revize
                            "
                            v-b-modal.StrKontrolGirisKanit
                            @click="Odenekid = TableDataVerileri.Ids[0]"
                            ><i class="fas fa-paperclip"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            v-if="!TableDataVerileri.Onay"
                            @click="
                              DeleteOdenekGrup(TableDataVerileri.GrupGuid)
                            "
                            ><i class="fas fa-trash-alt"></i
                          ></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit
        :Id="DataUpdate"
        :AddEdit="AddEdit"
        v-show="AddEdit"
        @TableUpdate="Get()"
      />
      <Onay :Id2="DataUpdate2" v-show="DataUpdate2" @TableUpdate="Get()" />
      <SonGun @UpdateSonGun="Get()" />
      <Iade :Id3="DataUpdate3" v-show="DataUpdate3" @TableUpdate="Get()" />
      <StrKontrolGirisKanit
        :Odenekid="Odenekid"
        

      />
      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrOdenekTalep.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrOdenekTalep.Filtreleme.Content") }}

            <div class="mb-3">
              <BirimSecimi
                :title="$t('StrOdenekTalep.Filtreleme.BirimId')"
                :sutun="'0'"
                :title_position="'mb-3'"
                :selected="Filter.BirimId"
                :labels_lg="'3'"
                :YetkiKontrol="1"
                :multiple="false"
                :BirimTipId="null"
                @Secilmis_Idler="Filter.BirimId = $event"
                :v="$v.Filter.BirimId"
              />
            </div>
            <!--        <div class="mb-3>">
            <div  style="float: right" class="form-check">
              <input id="checkbox-1" class="form-check-input" @click="IsLevelTwo = !IsLevelTwo" type="checkbox" name="checkbox-1" v-model="IsLevelTwo">
              <label for="checkbox-1" class="form-check-label active"> İkinci Düzey Kullan </label></div>
          </div> -->
            <div class="mb-3">
              <b-form-group
                class="mb-3"
                id="example text"
                label="Hesap Kodları"
                label-for="text"
              >
                <treeselect
                  @search-change="hesapkodu_sorgula($event)"
                  :async="true"
                  :load-options="loadOptions"
                  :multiple="false"
                  searchPromptText="Aramak için yazın..."
                  placeholder="Seçiniz..."
                  v-model="Filter.Hesapkodid"
                />
                <treeselect-value :value="Filter.Hesapkodid" />
              </b-form-group>
            </div>

            <div class="mb-3">
              <div class="mb-3">
                <formcombobox
                  :FormDataType="{
                    FieldName: 'Yıl',
                    Field: 'combobox',
                    FieldTitle: 'Yıl',
                    ComboDataArray: this.Yillar,
                  }"
                  :Value="Filter.Yil"
                  :v="$v.Filter.Yil"
                  @input="Filter.Yil = $event"
                />
              </div>
            </div>
            <div class="mb-3">
              <div class="mb-3">
                <formcombobox
                  :FormDataType="{
                    FieldName: 'Ay',
                    Field: 'combobox',
                    FieldTitle: $t('StrOdenekTalep.Filtreleme.Ay'),
                    ComboDataArray: this.Aylar2,
                  }"
                  :Value="Filter.Ay"
                  :v="$v.Filter.Ay"
                  @input="Filter.Ay = $event"
                />
              </div>
            </div>

            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Onay',
                  Field: 'combobox',
                  FieldTitle: $t('StrOdenekTalep.Filtreleme.Onay'),
                  ComboDataArray: ComboBoxOnay,
                }"
                :Value="Filter.Onay"
                :v="$v.Filter.Onay"
                @input="Filter.Onay = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Gidertur',
                  Field: 'combobox',
                  FieldTitle: $t('StrOdenekTalep.Filtreleme.Gidertur'),
                  ComboDataArray: this.Giderturs,
                }"
                :Value="Filter.Gidertur"
                :v="$v.Filter.Gidertur"
                @input="Filter.Gidertur = $event"
              />
            </div>

            <b-button
              @click="Get(), rightDrawer()"
              class="btn btn-primary"
              variant="primary"
            >
              {{ $t("StrOdenekTalep.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>

<style>
.red-background {
  background-color: #f8bbd0;
}
.green-background {
  background-color: #c8e6c9;
}
.default-background {
  background-color: #f0f0f0;
}
.box {
  padding: 20px;
  text-align: center;
}
</style>
